import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
    errorMessage,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { deleteApplicantRoute, updateRockerboxWotcRoute } from '../api/constant';
import { rockerboxApplicantKey, rockerboxEmployerKey } from '../constants';

type useDeleteRockerboxApplicantProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteRockerboxApplicant = ({
    setErrorText = () => { },
}: useDeleteRockerboxApplicantProps) => {
    const client = useQueryClient();

    const { mutate: deleteApplicant, isLoading: isdeleteApplicantLoading } =
        useMutation({
            mutationFn: (variables: {
                application_id: number | string;
            }) =>
                axiosInstance
                    .post(deleteApplicantRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries([rockerboxApplicantKey]);
                setErrorText('');
            },
            onError: () => {
                setErrorText(errorMessage);
            },
        });

    return {
        deleteApplicant,
        isdeleteApplicantLoading,
    };
};
